'use client';

import { Button } from '@/components/ui/button';
import { ROUTES } from '@/constants/routes';
import { useAppContext } from '@/context/app-context';

export const HyperReportBtn = () => {
    const { goToPage } = useAppContext();

    return (
        <Button variant="outline" onClick={() => goToPage(ROUTES.Welcome)}>
            Get Your Hyper Report
        </Button>
    );
};
